import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import Postcard from "@/components/Postcard";
import { api } from "@/lib/api";

export default function RequestAccess() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email) {
      toast.error("Name and email required");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/access-requests", { name, email });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not submit request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="request-access-page">
      <div className="hidden lg:flex flex-col bg-[var(--ink)] text-[#FBF7F2] p-12 w-[42%] relative overflow-hidden">
        <Logo to="/" inverse size={32} />
        <div className="mt-12">
          <span className="eyebrow" style={{ color: "rgba(255,255,255,0.6)" }}>◆ Invite only</span>
          <h2 className="h-display mt-4 text-[44px] text-white leading-[1] max-w-[400px]">
            Request your<br />access code.
          </h2>
          <p className="mt-5 text-[15px] leading-[1.6] text-[#cbb9a8] max-w-[400px]">
            Nirno is invite-only right now. Tell us who you are and we'll email you a code to join.
          </p>
        </div>
        <div className="mt-auto pt-8 max-w-[340px]">
          <Postcard />
        </div>
      </div>

      <div className="flex-1 flex items-start lg:items-center justify-center px-6 py-10 sm:py-16">
        <div className="w-full max-w-[440px]">
          <div className="lg:hidden mb-8"><Logo /></div>

          {done ? (
            <div data-testid="request-access-success">
              <span className="eyebrow">◆ Request received</span>
              <h2 className="h-display text-[36px] mt-2 mb-4">Check your inbox soon.</h2>
              <p className="text-[14px] text-[var(--ink2)] leading-[1.6]">
                We'll review your request and email your 6-digit access code to <strong>{email}</strong> once approved.
              </p>
              <Link to="/auth?mode=signin" className="block text-center mt-8 btn btn-ghost btn-lg full">
                ← Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <span className="eyebrow">◆ Get access</span>
              <h2 className="h-display text-[36px] mt-2 mb-6">Request access.</h2>
              <form onSubmit={handleSubmit}>
                <div className="inp-wrap">
                  <label className="lbl">Full name</label>
                  <input
                    className="inp"
                    placeholder="Arjun Mehra"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    data-testid="request-access-name"
                  />
                </div>
                <div className="inp-wrap">
                  <label className="lbl">Email</label>
                  <input
                    className="inp"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="request-access-email"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  data-testid="request-access-submit"
                  className="btn btn-solid btn-lg full mt-3"
                >
                  {submitting ? "…" : "Request access →"}
                </button>
              </form>
            </>
          )}

          <div className="mt-8 text-center text-[12px] text-[var(--ink3)]">
            <Link to="/" className="hover:text-[var(--ink)]">← Back to home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
